<script>
	import { API} from '../global.js'
	import Presentacion from './presentacion.svelte'
	
	let marcado = {IdRendicionDAC:0}
	let agrupado = true

	
	$: fetchData = (async() => {
		const res = await fetch(`${API}/rendiciones`)
		const data = await res.json()
		
		//console.log(data[0])
		if(res.ok) return data
		else throw new Error(data)
	})
	const marcar = (it) => {
		marcado=it
	}


</script>

{#if marcado.IdRendicionDAC==0}
	
<div class="container-fluid my-4" style="max-height: 90vh;">
	{#await fetchData()}
		<p>Loading.....</p>
	{:then data}
		<table class="table table-sm table-hover">
			<thead>
				<tr>
					<th class="border" colspan="6">Presentacion</th>
					<th class="border" colspan="2">Desde/Hasta</th>
					<th class="border" colspan="2">Total</th>
					<th class="border" colspan="2">Rechazo</th>
					<th class="border">Pesos</th>
					<th class="border">Dolar</th>
				</tr>
			</thead>
			<tbody>
			{#each data.data as item, index}
				<tr class="{item.IdRendicionDAC==marcado.IdRendicionDAC ? 'bg-orange-300' : ''} hover:bg-orange-200" on:click={()=> marcar(item)}>
					<td class="px-2 py-1 border">{item.IdRendicionDAC}</td>
					<td class="px-2 py-1 border">{item.Sociedad}</td>
					<td class="px-2 py-1 border">{item.Referencia}</td>
					<td class="px-2 py-1 border">{item.IdMedioPagoDetalle}</td>
					<td class="px-2 py-1 border">{item.MedioPagoDetalle}</td>
					<td class="px-2 py-1 border">{item.FechaContable}</td>
					<td class="px-2 py-1 border">{item.FechaDesde}</td>
					<td class="px-2 py-1 border">{item.FechaHasta}</td>
					<td class="px-2 py-1 border text-right">{item.cantidad_total}</td>
					<td class="px-2 py-1 border text-right">{item.total_importe.toFixed(2)}</td>
					<td class="px-2 py-1 border text-right">{item.cantidad_rechazado}</td>
					<td class="px-2 py-1 border text-right">{item.importe_rechazado.toFixed(2)}</td>
					<td class="px-2 py-1 border text-right">{item.importe_pesos.toFixed(2)}</td>
					<td class="px-2 py-1 border text-right">{item.importe_dolar.toFixed(2)}</td>
				</tr>
			{/each}
		</tbody>
		</table>
	{/await}
</div>


{:else}
		<button class="btn btn-sm btn-danger mb-2 p-2" on:click={ () => marcado={IdRendicionDAC:0}}>
			<i class="bi bi-arrow-left-short"></i>Volver
		</button>
		<div class="row">
			<div class="col-4">
				<div class="row">
			
					<div class="col-4">IdRendicionDAC</div><div class="col-8 px-2 py-1 border">{marcado.IdRendicionDAC}</div>
				
					<div class="col-4">Sociedad</div><div class="col-8 px-2 py-1 border">{marcado.Sociedad}</div>
					<div class="col-4">Referencia</div><div class="col-8 px-2 py-1 border">{marcado.Referencia}</div>
					<div class="col-4">IdMedioPagoDetalle</div><div class="col-8 px-2 py-1 border">{marcado.IdMedioPagoDetalle}</div>
					<div class="col-4">MedioPagoDetalle</div><div class="col-8 px-2 py-1 border">{marcado.MedioPagoDetalle}</div>
					<div class="col-4">FechaContable</div><div class="col-8 px-2 py-1 border">{marcado.FechaContable}</div>
					<div class="col-4">FechaDesde</div><div class="col-8 px-2 py-1 border">{marcado.FechaDesde}</div>
					<div class="col-4">FechaHasta</div><div class="col-8 px-2 py-1 border">{marcado.FechaHasta}</div>
					<div class="col-4">cantidad_total</div><div class="col-8 px-2 py-1 border text-right">{marcado.cantidad_total}</div>
					<div class="col-4">total_importe</div><div class="col-8 px-2 py-1 border text-right">{marcado.total_importe.toFixed(2)}</div>
					<div class="col-4">cantidad_rechazado</div><div class="col-8 px-2 py-1 border text-right">{marcado.cantidad_rechazado}</div>
					<div class="col-4">importe_rechazado</div><div class="col-8 px-2 py-1 border text-right">{marcado.importe_rechazado.toFixed(2)}</div>
					<div class="col-4">importe_pesos</div><div class="col-8 px-2 py-1 border text-right">{marcado.importe_pesos.toFixed(2)}</div>
					<div class="col-4">importe_dolar</div><div class="col-8 px-2 py-1 border text-right">{marcado.importe_dolar.toFixed(2)}</div>
					<div class="col-12">
						<input type="checkbox" bind:checked={agrupado}>
					</div>
				</div>

			</div>
			<div class="col-7 overflow-auto ml-4" style="max-height: 400px;">
				<Presentacion bind:rendicion={marcado} agrupado={agrupado} />
				
			</div>
		</div>
		
{/if}


